import Link from "next/link";
import { ThemeToggle } from "./ThemeToggle";

export function Header() {
  return (
    <header className="sticky top-0 z-10 flex items-center justify-between border-b border-[var(--color-border)] bg-[var(--color-surface-0)]/95 px-6 py-3 backdrop-blur">
      <Link href="/" className="flex items-baseline gap-2">
        <span className="font-mono text-sm font-semibold tracking-tight text-[var(--color-accent-strong)]">
          RL
        </span>
        <span className="text-sm font-medium text-[var(--color-text-primary)]">
          Route Listings
        </span>
      </Link>
      <div className="flex items-center gap-4">
        <Link
          href="/listings/add"
          className="text-sm text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)]"
        >
          Add Listing
        </Link>
        <Link
          href="/settings"
          className="text-sm text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)]"
        >
          Settings
        </Link>
        <ThemeToggle />
      </div>
    </header>
  );
}
